module.exports = __webpack_public_path__ + "static/media/hypoxia_bg.aa6526f8.jpg";